import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';

import * as $ from 'jquery';

@Component({
  selector: 'saleshistorycustomerwise-template',
  template: require('./saleshistorycustomerwiseTemplate.html'),
  styles: [``],
})

export class saleshistorycustomerwiseTemplateComponent implements OnInit, OnDestroy {
  static parameters = [HttpClient, UtilityService]
  @Input('queueType') queueType: any;
  @Input('ProductID') ProductID:any;
  @Input('ProductDesc') ProductDesc:any;
  @Input('ProductPackSize') ProductPackSize:any;
  @Input('CustomerID') CustomerID:any;
  @Input('dValue') dValue: any;

  public defaultColDef: any;
  public RequestEmailList: any;
  public RequestListcolumnDefs: any;
  public emailRequestTimeout: any;
  public gridEmailListColumnApi: any;
  public gridEmailListApi: any;
  public gridsaleshistorylistColumnApi: any;
  public gridsaleshistorylistApi: any;

  unitInfo: any;
  rowSelectionSingle: any;
  OldSalesHistorycolumnDefs: any;
  saleshistorylist:any = [];
  busy: Subscription;
  AllRecord:any = 0;

  constructor(private http: HttpClient, public utilityService: UtilityService) {
    this.http = http;
    this.utilityService = utilityService;
    this.unitInfo = JSON.parse(localStorage.getItem('permission') as any)[0];
    this.defaultColDef = {
      resizable: true,
    };
    this.rowSelectionSingle = 'single';
  }

  ngOnInit() {
    this.RequestListcolumnDefs = [
            { headerName: 'Inv No', field: 'Invoice_No', width: 120 },
            { headerName: 'Inv Dt', field: 'Invoice_Date', width: 100 },
            { headerName: 'Batch No', field: 'Batch_No', width: 100 },
            //{ headerName: 'Exp Dt', field: 'Expiry_Date', width: 80 },
            { headerName: 'Qty', field: 'Qty', width: 70, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Free_Qty', field: 'Free_Qty', width: 70, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Sch%', field: 'Sales_Scheme', width: 70, cellStyle: { 'text-align': 'right' } },
            { headerName: 'MRP', field: 'MRP', width: 80, cellStyle: { 'text-align': 'right' } },
            { headerName: 'PTR', field: 'PTR', width: 80, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Rate', field: 'Rate', width: 80, cellStyle: { 'text-align': 'right' } },
            { headerName: 'T. Rate', field: 'T_Rate', width: 80, cellStyle: { 'text-align': 'right' } },
            { headerName: 'CP', field: 'CP', width: 80, cellStyle: { 'text-align': 'right' } },
            {headerName: 'Disc%', field: 'ItemDiscount', width: 80, cellStyle: {'text-align': 'right'} },
            {headerName: 'SGST%', field: 'SGST_Value', width: 80, cellStyle: {'text-align': 'right'} },
            {headerName: 'CGST%', field: 'CGST_Value', width: 80, cellStyle: {'text-align': 'right'} },
            {headerName: 'IGST%', field: 'IGST_Value', width: 80, cellStyle: {'text-align': 'right'} },
            { headerName: 'Total Amt', field: 'Total_Amt', width: 100, cellStyle: { 'text-align': 'right' } },
        ]
    this.Get_Product_Old_Sales_History();
  }

  ngOnDestroy() {
    clearTimeout(this.emailRequestTimeout);
  }

  onsaleshistorylistGridReady(params: { api: any; columnApi: any }) {
    this.gridsaleshistorylistApi = params.api;
    this.gridsaleshistorylistColumnApi = params.columnApi;
    
  }

  Get_Product_Old_Sales_History(){
    this.saleshistorylist = [];

    let data = {
        "Company_ID": this.unitInfo.Company_ID,
        "Unit_ID": this.unitInfo.Unit_ID,
        "Customer_ID": this.CustomerID,
        "Product_ID": this.ProductID,
        "AllRecord": this.f_chknum(this.AllRecord),
    }

    this.busy = this.http.post('/api/salesinvoices/Get_Product_Sales_History', data)
    .subscribe(response => {
        this.saleshistorylist = response;
    });   
  }


  f_chkString(p_value: any) {
    var Val = (p_value ? p_value.toString() : '').trim();
    return Val;
  }

  f_chknum(p_value) {
      var Val = Number(p_value);
      if (Val) {
          return Val;
      }
      return 0;
  }
}
